const getDefaultLanguage = ({
  defaultLanguage,
  supported
}) => {
  const browserLanguage = navigator.language.split("-").shift() || "";
  return supported.includes(browserLanguage) ? browserLanguage : defaultLanguage;
};
const loadCloudTranslation = async (language, {
  cloudServiceUrl,
  logger
}) => {
  const url = `${cloudServiceUrl}/${language}.json`;
  logger.debug(`Loading translations from TranslationsService: ${url}`, {
    language,
    url
  });
  const response = await fetch(url, { method: "GET" });
  return response.json();
};
const core = {
  loadCloudTranslation,
  getDefaultLanguage
};
export {
  core
};
